import { Buffer } from 'buffer';
import process from 'process';

window.global = window;
global.Buffer = Buffer;
global.process = process;